import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthContext } from './AuthContext.jsx';

const queryClient = new QueryClient();

export const DemoAuthProvider = ({ children }) => {
	const [sessionInfo, setSessionInfo] = useState(null);

	useEffect(() => {
		//axios.get('/react-app/json/session-info.json').then(res => {
		axios.get('/api/trivia/demo/session-info').then(res => {
			setSessionInfo(res.data);
		})
	}, []);

	return (
		<QueryClientProvider client={queryClient}>
			<AuthContext.Provider value={{ sessionInfo, setSessionInfo }}>
				{children}
			</AuthContext.Provider>
		</QueryClientProvider>
	);
};

export default DemoAuthProvider;
